import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListnerMixin from 'next/javascripts/mixins/event-listener-mixin';
import pageMixin from 'next/javascripts/mixins/page-mixin';
import Slide from 'next/javascripts/components/slide';

import 'next/stylesheets/components/page/slide-page';

Component('tr-slide-page', {
  extends: [Slide],

  mixins: [eventListnerMixin, pageMixin],

  connected() {
    if (this.opened) {
      document.body.classList.add('slide-scroll-lock');
    }
  },

  ready() {
    this.listenTo(document, 'click', (event) => {
      if (this.opened && !closest(event.target, '.slide__container')) {
        this.close({ trigger: event.target });
      }
    });
  },

  setContent(content = '') {
    this.querySelector('.page__content').innerHTML = content;
  },

  disconnected() {
    this.stopListening();
  },
});
